import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AppService } from "../../../app.service";
import { NotificationService } from "../../../core/services/notification.service";
import { ComponentPageBase } from "../../../shared/components/component-page-base/component-page-base";
import { CategoryType } from "../../../shared/enums/category-type.enum";
import { EntityViewModel } from "../../../shared/models/core/EntityViewModel";
import { KeyValueObject } from "../../../shared/models/core/KeyValueObject";
import { ServiceItem, ServiceRequestTypeItem } from "../../../shared/models/services/service-item";
import { CategoryServicesService } from "../../../shared/services/category-services.service";
import { LookupService } from "../../../shared/services/lookup.service";
import { RequestTypeWithCategoriesModel } from "../../../shared/models/request/request-type-with-categories-model";
import { RequestCategotyWithTypesModel } from "../../../shared/models/request/request-categoty-with-types-model";
import { RequestTypeService } from "../../../shared/services/request-type.service";
import { RequestCategoryService } from "../../../shared/services/request-categoty.service";
import { forkJoin } from "rxjs";
import { GridComponent } from "@progress/kendo-angular-grid";
import { Guid } from "guid-typescript";

@Component({
	selector: 'service-page',
	templateUrl: './service.page.html',
	styleUrls: [
		'./service.page.scss',
		'../../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
		'../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss'
	]
})
export class ServicePage extends ComponentPageBase<ServiceItem> implements OnInit {

	@ViewChild("serviceRequestTypesGrid") serviceRequestTypesGrid: GridComponent;

	activeIdString: any = "main";
	categoryTypeId = <number>CategoryType.services;
	areAllRequestTypesSelected: boolean = false;

	dependentRequestTypes: RequestTypeWithCategoriesModel[] = [];
    dependentRequestCategories: RequestCategotyWithTypesModel[] = [];
    requestTypes: RequestTypeWithCategoriesModel[] = [];
    requestCategories: RequestCategotyWithTypesModel[] = [];

	requestTypeDefaultItem = { id: null, name: "Не выбрано" } as RequestTypeWithCategoriesModel;
	requestCategoryDefaultItem = { id: null, name: "Не выбрано" } as RequestCategotyWithTypesModel;

	constructor(
		protected route: ActivatedRoute,
		protected router: Router,
		protected appService: AppService,
		protected notificationService: NotificationService,
		protected dataService: CategoryServicesService,
		protected lookupService: LookupService,
		protected requestTypeService: RequestTypeService,
		protected requestCategoryService: RequestCategoryService
	) {
		super(route, router, appService, notificationService, dataService);
		this.listPageRoutePath = 'categories/services';
		this.appService.pageTitle = 'Новая услуга';
	}

	ngOnInit(): void {
		const requestTypes$ = this.requestTypeService.getRequestTypesWithCategories();
		const requestCategories$ = this.requestCategoryService.getRequestCategoriesWithTypes();

		forkJoin(requestTypes$, requestCategories$)
			.subscribe(([requestTypes, requestCategories]) => {
				this.requestTypes = requestTypes;
				this.requestCategories = requestCategories;
				this.dependentRequestTypes = requestTypes;
				this.dependentRequestCategories = requestCategories;

				this.entityId = this.route.snapshot.paramMap.get('serviceId');

				if (this.entityId != null) {
					this.dataService.getById(+this.entityId)
						.subscribe(vm => {
							this.entityName = `${vm.entity.name}`;
							this.dataBind(vm);
							this.entityViewModel.entity.serviceRequestTypes.forEach(x => x.uid = Guid.create().toString());
						});
				} 
				else {
					this.entityViewModel = new EntityViewModel<ServiceItem>();
					this.entityViewModel.entity = new ServiceItem();
					this.entityViewModel.entity.createdDate = new Date();
					this.canEditForm = true;
					this.isNew = true;
				}
			});
	}

	get toggleAllText() {
		return this.areAllRequestTypesSelected ? 'Отменить все' : 'Выбрать все';
	}

	createNewServiceRequestType(): ServiceRequestTypeItem {
		let serviceRequestType = new ServiceRequestTypeItem();
		serviceRequestType.uid = Guid.create().toString();

		return serviceRequestType;
	}

	addNewServiceRequestType() {
		this.serviceRequestTypesGrid.addRow(this.createNewServiceRequestType());
		
		this.dependentRequestTypes = this.requestTypes;
		this.dependentRequestCategories = this.requestCategories;
	}

	requestTypeChange(requestTypeId: number) {
        if (requestTypeId != null && requestTypeId != 0) {
            this.dependentRequestCategories = this.requestCategories.filter(x => 
                x.requestTypeIds.some(rt => rt == requestTypeId));
        }
        else {
            this.dependentRequestCategories = this.requestCategories;
        }
    }

    requestCategoryChange(requestCategoryId: number) {
        if (requestCategoryId != null && requestCategoryId != 0) {
            this.dependentRequestTypes = this.requestTypes.filter(x => 
                x.requestCategoryIds.some(rc => rc == requestCategoryId));
        }
        else {
            this.dependentRequestTypes = this.requestTypes;
        }
    }

	canSaveServiceRequestType(item: ServiceRequestTypeItem): boolean {
		let hasSameItem = this.entityViewModel.entity.serviceRequestTypes.some(x => 
			x.requestTypeId == item.requestTypeId && 
			x.requestCategoryId == item.requestCategoryId &&
			x.uid != item.uid);

		return item.requestTypeId != null && item.requestCategoryId != null && !hasSameItem;
	}

	editServiceRequestType({ dataItem }: any) {
		this.requestTypeChange(dataItem.requestTypeId);
		this.requestCategoryChange(dataItem.requestCategoryId);
	}

	saveServiceRequestType({ dataItem }: any) {
		dataItem.requestTypeName = this.requestTypes.find(x => x.id == dataItem.requestTypeId).name;
		dataItem.requestCategoryName = this.requestCategories.find(x => x.id == dataItem.requestCategoryId).name;
	}

	afterSaveChanges(): void {
		if (!this.isNew) {
			this.dataService.getById(this.entityViewModel.entity.id)
				.subscribe(vm => {
					this.dataBind(vm);
				});
		}
		super.afterSaveChanges();
	}
}
